import { push } from 'connected-react-router';

import { createLead, fetchLead, updateLead } from './api/lead';
import { setMessage } from './utils';

export const FETCH_LEAD = 'FETCH_LEAD';
export const RECEIVE_LEAD = 'RECEIVE_LEAD';
export const SEARCH_ERROR = 'SEARCH_ERROR';
export const create = (lead, formik) => async (dispatch) => {
  try {
    let result = await createLead({...lead, dob: lead.dob + ' 07:00:00'});
    dispatch({ type: RECEIVE_LEAD, payload: result });
    dispatch(push('/leads'));
  } catch (error) {
    if (formik) {
      (error?.response?.data?.errors || []).forEach((e) => formik.setFieldError(e.code, e.message));
    }
    dispatch(setMessage(error?.response?.data?.message || ' ', error?.response?.data?.errors));
  }
};
export const update = (leadId, data) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_LEAD });
    let result = await updateLead(leadId, {...data, dob: data.dob + ' 07:00:00'});
    dispatch({ type: RECEIVE_LEAD, payload: result });
    dispatch(push('/leads'));
  } catch (error) {
    dispatch({ type: SEARCH_ERROR });
    dispatch(setMessage(error?.response?.data?.message || ' ', error?.response?.data?.errors));
  }
};
export const fetch = (leadId) => async (dispatch) => {
  try {
    dispatch({ type: 'FETCH_LEAD', payload: leadId });
    let result = {};
    if (leadId !== 'new') {
      result = await fetchLead(leadId);
    }
    dispatch({ type: RECEIVE_LEAD, payload: result });
  } catch (error) {
    dispatch(setMessage(error?.response?.data?.message || ' ', error?.response?.data?.errors));
    dispatch(push('/'));
  }
};
